import React from 'react';
import PageHeaderSection from './PageHeaderSection';
import ListPageLayout, { ListPageHeader, ListLoadingSpinner } from './ListPageLayout';

/**
 * Standard shell while a page waits for initial data.
 * Always uses ListLoadingSpinner — the single product loader for page-level waits.
 */
export default function PageLoadingShell({
    title,
    subtitle,
    variant = 'list-page',
    showBack = true,
    backTo = null,
    label = null,
    className = '',
}) {
    if (variant === 'page-shell' || variant === 'page-shell-form') {
        const shellClass = variant === 'page-shell-form' ? 'page-shell-form' : 'page-shell space-y-6';
        return (
            <div className={`${shellClass} ${className}`.trim()}>
                <PageHeaderSection
                    title={title}
                    subtitle={subtitle}
                    showBack={showBack}
                    backTo={backTo}
                />
                <ListLoadingSpinner label={label} />
            </div>
        );
    }

    if (variant === 'bare') {
        return (
            <div className={className}>
                <ListLoadingSpinner label={label} />
            </div>
        );
    }

    return (
        <ListPageLayout className={className}>
            <ListPageHeader
                title={title}
                subtitle={subtitle}
                showBack={showBack}
                backTo={backTo}
            />
            <ListLoadingSpinner label={label} />
        </ListPageLayout>
    );
}
